import {createAction, props} from '@ngrx/store';

export const saveKoppeling = createAction('[Privacydashboard preview] Save koppeling', props<{koppelpartij: {uuid: string, naam: string}}>());

export const deleteKoppeling = createAction('[Privacydashboard preview] Delete koppeling', props<{koppelpartij: {uuid: string, naam: string}}>());
